import { useUserContext } from "@magento/peregrine/lib/context/user";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { bool, shape, string } from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSocialLoginContext } from "../../context";
import SocialButtons from "../SocialButtons";
import defaultClasses from "./socialAuthentication.css";
var SocialAuthentication = props => {
  var {
    mode,
    isPopup,
    showCreateAccount,
    textSeparator,
    bottomSeparator,
    onClick,
    children
  } = props;
  var {
    buttons,
    isEnabled,
    buttonPosition,
    enabledModes
  } = useSocialLoginContext();
  var [{
    isSignedIn
  }] = useUserContext();
  if (!isEnabled || !enabledModes.includes(mode) || isSignedIn) {
    return null;
  }
  var classes = mergeClasses(defaultClasses, props.classes);
  var separator = textSeparator || mode !== "popup" ? /*#__PURE__*/React.createElement("div", {
    className: classes.separator
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.separatorIcon
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "amSocialLogin.separator",
    defaultMessage: "or"
  }))) : null;
  var separatorBottom = textSeparator ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.separatorBottom, " ").concat(children ? classes.withDisclaimer : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.separatorIcon
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: mode === "popup" ? textSeparator ? textSeparator : "amSocailLogin.separatorBottomPopup" : "amSocialLogin.separatorBottom",
    defaultMessage: "or"
  }))) : null;
  var rootClass = isPopup ? "".concat(classes.root_popup, " ").concat(classes[buttonPosition]) : "".concat(classes.root, " ").concat(classes[mode]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClass
  }, separator, /*#__PURE__*/React.createElement(SocialButtons, {
    buttons: buttons,
    showCreateAccount: showCreateAccount,
    mode: mode,
    onClick: onClick,
    hasBottomSeparator: !!bottomSeparator,
    disclaimer: children
  }), bottomSeparator ? separatorBottom : null);
};
SocialAuthentication.propTypes = {
  classes: shape({
    root: string
  }),
  mode: string,
  isPopup: bool
};
export default SocialAuthentication;